<script lang="ts" setup>
withDefaults(defineProps<{
  loading?: boolean;
}>(), {
  loading: false
});
</script>

<template>
  <div class="pl-app-page" v-bind="$attrs">
    <div v-if="loading" class="page-loading">
      <slot name="load-indicator">
        <SharedCircleLoader />
      </slot>
    </div>
    <slot v-else />
  </div>
</template>

<style lang="scss">
.pl-app-page {
  @apply p-3xs;

  .page-loading {
    @apply flex justify-center items-center;
    @apply h-full;
  }
}
</style>
